/**
 * Cores padronizadas para o Wizard de Relatórios
 */
export const RELATORIO_CORES = {
  // Cores principais
  PRIMARIA: '#006533',      // Verde escuro
  SECUNDARIA: '#d6ac41',    // Dourado/Amarelo
  TERCIARIA: '#fefefe',     // Quase branco
  
  // Cores de status (manter para calendário)
  SUCESSO: '#28a745',       // Verde (apenas para calendário)
  PERIGO: '#dc3545',        // Vermelho (apenas para botões de excluir)
  AVISO: '#ffc107',         // Amarelo (apenas para calendário)
  INFO: '#17a2b8',          // Azul (apenas para calendário)
  
  // Cores neutras
  CINZA_CLARO: '#f8f9fa',
  CINZA_MEDIO: '#adb5bd',
  CINZA_ESCURO: '#6c757d',
  BRANCO: '#ffffff',

  // Estilo minimalista (alinhado à home / Corregedoria)
  BORDA_CARD: '#e9ecef',
  SOMBRA_CARD: '0 1px 3px rgba(0,0,0,0.05)',
} as const;
